<template>
  <form-code-verify
    ref="codeVerifyForm"
    :contact-detail="contactDetail"
    :reason="reason"
    :type="type"
    :pass-form-data="passFormData"
    @error-send-code="emit('close')"
    @code-verified="emit('success', $event)"
    @close="emit('close')"
    @update:is-loading="isLoading = $event"
  />
</template>

<script setup lang="ts">
import type { IChangeFormData } from '@skeleton/core/types';

withDefaults(defineProps<{
  contactDetail: string;
  reason?: 'registration' | 'phoneVerification' | 'changingPass' | 'emailVerification';
  type: 'email' | 'phone';
  passFormData?: IChangeFormData;
}>(), {
  contactDetail: '',
});

const emit = defineEmits([
  'close',
  'success',
  'update:isLoading',
]);

const isLoading = ref(false);
const codeVerifyForm = ref(null);

const sendVerifyCode = async (): Promise<void> => {
  await codeVerifyForm.value?.sendVerifyCode();
};

const verifyCode = async (): Promise<void> => {
  await codeVerifyForm.value?.verifyCode();
};

defineExpose({
  sendVerifyCode,
  verifyCode,
});

watch(isLoading, (newValue) => {
  emit('update:isLoading', newValue);
});
</script>
